import React from "react"
import authentication from "@irati/auth"
import styled, {css} from "styled-components"
import {Recognition} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import {H4, H6, Label} from "@irati/ui/src/Typography"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import Expander from "@irati/ui/src/Expander"
interface Props {
  recognition: Recognition
}
const Container = styled(Flex)`
  ${({theme}) => css`
    justify-content: center;
    flex-direction: column;
    gap: ${theme.spacing.half};
    background-color: ${theme.colors.tertiary.y_200};
    padding: ${theme.spacing.oneAndHalf};
    border-radius: ${theme.spacing.one};
  `}
`
const CustomRewardDetails = (props: Props) => {
  const {recognition} = props
  const {formatMessage, formatPlural} = useIntl()
  const customReward = recognition?.customReward
  const isReceiver = recognition.receivers?.results.some((receiver) => receiver.uuid === authentication.user().uuid)
  const isSender = recognition.createdBy?.uuid === authentication.user().uuid
  if ((!isReceiver && !isSender) || !customReward) {
    return null
  }
  const pluralRewards = formatPlural(recognition.receivers?.results.length)
  const messages = {
    receiver: "platform.statementItem.adminReward.rewarded.received.primaryDetails.title.receiver",
    sender: `platform.rewards.sent.${pluralRewards}`
  }
  const messageToShow = formatMessage(
    {
      id: isReceiver ? messages.receiver : messages.sender
    },
    {
      sender: firstnameLastname(recognition.createdBy),
      count: recognition.receivers?.results.length
    }
  )
  return (
    <Container>
      <Label>{messageToShow}</Label>
      <H4>{customReward.title}</H4>
      <Expander
        HeaderLabel={() => (
          <H6 weight="bold" marginRight={1}>
            <FormattedMessage id="platform.btn.viewDetails" />
          </H6>
        )}
        iconSize={14}
        flush>
        <Label>{customReward.redemptionInstructions}</Label>
      </Expander>
    </Container>
  )
}

export default CustomRewardDetails
